<template>
  <PageContent class="summary-page">
    <span class="summary-title">
      Please review and confirm your submission
    </span>

    <PanelV2
      type="w8"
      title="Personal Information"
      @nextClick="toNext()"
      mode="simple"
    >
      <template v-slot:title-solt>
        <span class="btn-action" @click="toEdit('EditPersonalInfo2')">EDIT</span>
      </template>
      <template v-slot:content-solt>
        <InfoBox :formdata="sections[0].data" :series="sections[0].columns.length"></InfoBox>
      </template>
    </PanelV2>

    <PanelV2
      type="w8"
      title="Business Information"
      @nextClick="toNext()"
      mode="simple"
    >
      <template v-slot:title-solt>
        <span class="btn-action" @click="toEdit('EditBusinessInfo3')">EDIT</span>
      </template>
      <template v-slot:content-solt>
        <InfoBox :formdata="businessData" :series="3"></InfoBox>
      </template>
    </PanelV2>

    <div class="summary-el-button-line bdoMarchent">
      <el-button @click="$router.go(-1)">Back</el-button>
      <el-button type="primary" @click="doConfirm">Confirm</el-button>
    </div>
  </PageContent>
</template>

<script>
import InfoBox from "../components/InfoBox";
import cityData from "../../common-data/city_select_data"
import API from "@/api";
export default {
  name: "BdoMerchantB",
  pRouter: "BdoMerchantA",
  components: {
    InfoBox,
  },
  data() {
    return {
      formData: {},
      // type : title标题 值传value上  , nomal普通左name右value  , wrap特殊换行 上name下value
      sections: [
        { name: 'Personal Information',
          editEntry: '/edit-personal-info',
          columns: [
            'personalInfo3',
            'email2',
            ''
          ],
          data: {left:[],middle:[],right:[]},
        },
      ],
      processNo: '5'
    };
  },
  created() {
    API.getBdoProcessData({
      ...this.formatCommitData()
    }).then((res) => {
      this.formData = res.obj
      this.formatColumn()
    })
  },
  computed: {
    businessData() {
      const data = this.formData
      let value = {
        left: [
          {
            type: "nomal",
            name: "Merchant ID",
            value: data.bdoBusinessDetails && data.bdoBusinessDetails.merchantId,
          },
          {
            type: "wrap",
            name: "Business Name",
            value: data.bdoBusinessDetails && data.bdoBusinessDetails.businessName,
          },
        ],
        middle: [
          {
            type: "nomal",
            name: "City",
            value: data.bdoBusinessDetails && data.bdoBusinessDetails.city && cityData.filter(val => val.value == data.bdoBusinessDetails.city)[0].label,
          },
          {
            type: "nomal",
            name: "Purpose of Application",
            value: data.bdoBusinessDetails && data.bdoBusinessDetails.purposeOfApplication ,
          },
        ],
        right: [
        ],
      }
      return value
    }
  },
  methods: {
    toEdit(name) {
      this.$router.push({name})
    },
    doConfirm() {
      API.confirmBdoProcess({
        processNo: this?.formData?.processNo || this.processNo,
        token: this.getCookieItem("token"),
      }).then((res) => {
        if (res.success) {
          this.$router.push({ path: "/finish-process" });
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.page-content {
  .btn-action {
    cursor: pointer;
  }
  .panel-v2.content-area {
    margin: 8px 0;
    height: 100%;
  }
  .summary-title {
    align-self: start;
    margin-top: 48px;
    margin-bottom: 16px;
    width: 100%;
    text-align: left;
    font: normal normal normal 20px/24px Nunito-bold;
    letter-spacing: 0px;
    color: #2e2e2e;
  }
  .with-two-panel {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .panel-v2.content-area {
      margin: 16px 0;
      height: 100%;
    }
  }
  .summary-el-button-line {
    display: flex;
    width: 100%;
    height: 112px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 16px #00000014;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
  }
  .bdoMarchent {
    margin-top: 8px;
  }
}
</style>
